const ENV = "dev";

export default ENV;
